import Text from 'particles/Text'
import React, { useMemo } from 'react'
import { useNewTranslation } from 'hooks'
import { STEP_TYPE_ENUM, TASK_TYPE_ENUM } from 'services/api/constants'
import { BaseProps } from '.'

interface TitleProps extends BaseProps {
    stepType: STEP_TYPE_ENUM
    stepNumber: number
    isScheduleLabel?: boolean
}

const Title: React.FC<TitleProps> = ({ taskType, stepType, stepNumber, isScheduleLabel }) => {
    const [t] = useNewTranslation()
    const { title, subtitle } = useMemo(() => {
        let titleKey = '',
            subtitleKey = ''
        switch (taskType) {
            case TASK_TYPE_ENUM.PURCHASE_PRODUCT:
                if (STEP_TYPE_ENUM.PURCHASE_PRODUCT === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.purchaseProductHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addProductDescriptionHeader'
                        subtitleKey = 'campaignEditor.createTask.addProductDescriptionSubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_PROOF_PHOTO === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitProductProofHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.setProofSubmissionHeader'
                        subtitleKey = 'campaignEditor.createTask.productPurchaseSetProofSubtext'
                    }
                }
                break
            case TASK_TYPE_ENUM.ATTEND_EVENT:
                if (STEP_TYPE_ENUM.ATTEND_EVENT === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.taskSchedule.scheduleEventHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addEventDetailsHeader'
                        subtitleKey = 'campaignEditor.createTask.addEventDetailsSubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_PROOF_PHOTO === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitProductProofHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.setProofSubmissionHeader'
                        subtitleKey = 'campaignEditor.createTask.setProofAttendEventSubtext'
                    }
                }
                break
            case TASK_TYPE_ENUM.IG_POST:
            case TASK_TYPE_ENUM.IG_POST_V02:
                if (STEP_TYPE_ENUM.SUBMIT_CONTENT_IG_POST === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitInstagramPostHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addInstagramPostGuideHeader'
                        subtitleKey = 'campaignEditor.createTask.submitInstagramPostSubtext'
                    }
                } else if (
                    STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_POST_URL === stepType ||
                    STEP_TYPE_ENUM.POST_TO_IG_POST === stepType
                ) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.publishInstagramPostHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addPublishInstructionHeader'
                        subtitleKey = 'campaignEditor.createTask.publishInstructionInstagramPostSubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_IG_POST === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitProofEngagementHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addProofEngagementHeader'
                        subtitleKey = 'campaignEditor.createTask.addMetricInstagramPostSubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_PROOF_IG_URL) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitProofHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addStepSubmitProofHeader'
                        subtitleKey = 'campaignEditor.createTask.addProofInstructionsInstagramPostSubtext'
                    }
                }
                break
            case TASK_TYPE_ENUM.IG_STORY:
            case TASK_TYPE_ENUM.IG_STORY_V02:
                if (STEP_TYPE_ENUM.SUBMIT_CONTENT_IG_STORY === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitInstagramStoryHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addInstagramStoryGuideHeader'
                        subtitleKey = 'campaignEditor.createTask.submitInstagramStorySubtext'
                    }
                } else if (STEP_TYPE_ENUM.POST_TO_IG_STORY === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.publishInstagramStoryHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addPublishInstructionHeader'
                        subtitleKey = 'campaignEditor.createTask.publishInstructionInstagramStorySubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_IG_SCREENSHOT === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitProofEngagementHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addProofEngagementHeader'
                        subtitleKey = 'campaignEditor.createTask.addMetricInstagramStorySubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_PROOF_IG_SCREENSHOT === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitProofHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addStepSubmitProofHeader'
                        subtitleKey = 'campaignEditor.createTask.addProofInstructionsInstagramPostSubtext'
                    }
                }
                break
            case TASK_TYPE_ENUM.IG_REEL:
                if (STEP_TYPE_ENUM.SUBMIT_CONTENT_IG_REEL === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitInstagramReelHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addInstagramReelGuideHeader'
                        subtitleKey = 'campaignEditor.createTask.addInstagramReelGuideSubtext'
                    }
                } else if (STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_REEL_URL === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.publishInstagramReelSubmitUrlHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addPublishInstructionHeader'
                        subtitleKey = 'campaignEditor.createTask.publishInstructionInstagramReelSubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_INSTAGRAM_REEL === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitEngagementHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addProofEngagementHeader'
                        subtitleKey = 'campaignEditor.createTask.addMetricInstagramReelSubtext'
                    }
                }
                break
            case TASK_TYPE_ENUM.FB_POST:
            case TASK_TYPE_ENUM.FB_POST_V02:
                if (STEP_TYPE_ENUM.SUBMIT_CONTENT_FB_POST === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitFacebookPostHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addFacebookPostGuideHeader'
                        subtitleKey = 'campaignEditor.createTask.submitFacebookPostSubtext'
                    }
                } else if (
                    STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_FACEBOOK_POST_URL === stepType ||
                    STEP_TYPE_ENUM.POST_TO_FB_POST === stepType
                ) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.publishFacebookPostHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addPublishInstructionHeader'
                        subtitleKey = 'campaignEditor.createTask.publishContentSubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_FACEBOOK_POST === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitProofHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addProofEngagementHeader'
                        subtitleKey = 'campaignEditor.createTask.addMetricFacebookPostSubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_PROOF_FB_URL === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitProofHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addProofInstructionsHeader'
                        subtitleKey = 'campaignEditor.createTask.addProofInstructionsFacebookPostSubtext'
                    }
                }
                break
            case TASK_TYPE_ENUM.TIKTOK_POST:
                if (STEP_TYPE_ENUM.SUBMIT_CONTENT_TIKTOK_POST === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitTikTokHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addTikTokGuideHeader'
                        subtitleKey = 'campaignEditor.createTas.fillInfo.addTikTokGuideSubtext'
                    }
                } else if (STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_TIKTOK_POST_URL === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.publishTikTokSubmitUrlHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addPublishInstructionHeader'
                        subtitleKey = 'campaignEditor.createTask.publishInstructionTikTokSubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_TIKTOK_POST === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitEngagementHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addProofEngagementHeader'
                        subtitleKey = 'campaignEditor.createTask.addMetricTikTokSubtext'
                    }
                }
                break
            case TASK_TYPE_ENUM.XIAOHONGSHU_POST:
                if (STEP_TYPE_ENUM.SUBMIT_CONTENT_XIAOHONGSHU_POST === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.XHSTaskSchedule1Title'
                    } else {
                        titleKey = 'campaignEditor.createTask.XHSStep1Title'
                        subtitleKey = 'campaignEditor.createTask.XHSStep1Subtext'
                    }
                } else if (STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_XIAOHONGSHU_POST_URL === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.XHSTaskSchedule2Title'
                    } else {
                        titleKey = 'campaignEditor.createTask.addPublishInstructionHeader'
                        subtitleKey = 'campaignEditor.createTask.XHSaddPublishInstructionSubtext'
                    }
                } else if (STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_XIAOHONGSHU_POST === stepType) {
                    if (isScheduleLabel) {
                        titleKey = 'campaignEditor.createTask.submitProofEngagementHeader'
                    } else {
                        titleKey = 'campaignEditor.createTask.addProofEngagementHeader'
                        subtitleKey = 'campaignEditor.createTask.XHSAddProofEngagementSubtext'
                    }
                }
                break
        }

        return {
            title: t(titleKey, { stepNumber }),
            subtitle: t(subtitleKey, { stepNumber }),
        }
    }, [t, taskType, stepType, stepNumber])

    return (
        <div className="step-title">
            <div className="step-number-title">
                <Text scale="bodyL700" color="primary">
                    {title}
                </Text>
            </div>
            {!isScheduleLabel ? (
                <Text color="secondary" className="step-subtitle">
                    {subtitle}
                </Text>
            ) : null}
        </div>
    )
}

export default Title
